import { NgModule } from '@angular/core';
import { CompanyLocationStateNameByAbbreviationPipe } from './company-location-state-name-by-abbreviation.pipe';
import { CompanyLocationCountryNameByAbbreviationPipe } from './company-location-country-name-by-abbreviation.pipe';

@NgModule({
	declarations: [CompanyLocationStateNameByAbbreviationPipe, CompanyLocationCountryNameByAbbreviationPipe],
	exports: [CompanyLocationStateNameByAbbreviationPipe, CompanyLocationCountryNameByAbbreviationPipe],
})
export class CompanyLocationNameByAbbreviationPipeModule {}
